import { render } from "./BusinessPage.vue?vue&type=template&id=de1019bc"
import script from "./BusinessPage.vue?vue&type=script&lang=js"
export * from "./BusinessPage.vue?vue&type=script&lang=js"

import "./BusinessPage.vue?vue&type=style&index=0&id=de1019bc&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__